var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 113,
    viewBox: "0 0 255 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.19 97.18L185.02 112.35",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.19 112.35L185.02 97.18",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5596 -13.09L0.519531 21.95",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5596 21.95L0.519531 -13.09",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.691 87.9296C246.749 83.8221 251.572 72.3392 247.465 62.2818C243.357 52.2245 231.874 47.4011 221.817 51.5086C211.76 55.616 206.936 67.0989 211.044 77.1563C215.151 87.2137 226.634 92.037 236.691 87.9296Z",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeDasharray: "5 5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.242 28.42C266.494 17.1328 278.625 -13.2988 267.338 -39.5508C256.051 -65.8029 225.619 -77.9343 199.367 -66.6471C173.115 -55.3599 160.984 -24.9283 172.271 1.32376C183.558 27.5758 213.99 39.7072 240.242 28.42Z",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeDasharray: "5 5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.847 -28.8533C207.696 -71.5687 178.619 -111.748 135.904 -118.596C93.1887 -125.444 53.0095 -96.368 46.1614 -53.6526C39.3132 -10.9372 68.3894 29.242 111.105 36.0901C153.82 42.9383 193.999 13.8621 200.847 -28.8533Z",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.762fbb9435812da6f6bce57c86428253.svg";
export { ForwardRef as ReactComponent };